module.exports = __webpack_public_path__ + "static/media/lead-magnet-thankyou-page-sample-template-1.e95ec88f.jpg";